export enum BonAllotissementSortingEnum {
  DATE_LIVRAISON = 'DATE_LIVRAISON',
  DATE_FABRICATION = 'DATE_FABRICATION'
}
